import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function AccordionUsage({ qa, language, currency,poiName }) {
  const [fontSize, setFontSize] = React.useState("20px");
  const [lineHeight, setLineHeight] = React.useState("10");

  const currency2 = currency?.find((item) => item.name === language || "en") 
  
  React.useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 640px)").matches) {
        setFontSize("10px");
        setLineHeight("2");
      } else {
        setFontSize("18px");
        setLineHeight("20");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  console.log("currency2", currency2);


  const sanitizeAnswer = (answer, language) => {
    return answer.replace(/\{(\d+)\}/g, (match, number) => {
      return language === "ar" && currency2?.value
        ? `SAR ${Number(number) * currency2?.value}`
        : `USD ${Number(number)*currency2?.value}`;
    });
  };


  // if (!Array.isArray(currency)) {
  //   return <div>Loading...</div>; // or a skeleton component
  // }

  console.log("sanitizeAnswer", sanitizeAnswer(qa?.[1]?.answer || "", language));

  return (
    <div>
      {qa?.map((i, key) => {
        const styledAnswer = i.answer?.replace(
          /<span[^>]*>/g,
          `<span style="font-size: ${fontSize}; line-height: ${lineHeight};">`
        );

        return (
          <Accordion key={key} sx={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${key}-content`}
              id={`panel${key}-header`}
              className="font-regular text-[#454545] -ml-3  max-sm:text-[16px]"
              sx={{ boxShadow: "none", marginLeft: -2 }}
            >
              {`What is ${i.question} of ${poiName}`}
            </AccordionSummary>
            <AccordionDetails
              className="font-regular text-[#454545] -ml-3 text-[20px] max-sm:text-[16px] leading-6 max-sm:leading-5"
              dangerouslySetInnerHTML={{
                __html: `<span class="override-htmlq">${sanitizeAnswer(
                  styledAnswer || "",
                  language
                )}</span>`,
              }}
            />
          </Accordion>
        );
      })}
    </div>
  );
}

export default AccordionUsage;
